import Hosts from '../../Hosts';

const object_type = 'intranet/projetos'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = companycode => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/projetos'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        ativo: true,
        tipoProjeto: '',
        codProjeto: '',
        nome: [{
            tipo: {},
            linha: {},
            nomeCompleto: '',

        }],
        empresa: '',
        nLicenca: '',
        date: [{
            available: '',
            creation: '',
            modified: '',
            published: '',
        }],
        assistenciaMensal: [
           
        ],
        tickets: [],
        assistenciaRemota: false,
        tempoAssistencia: '',
        assistenciaPermitida: false,
        identificacao: {
            tipo_identificacao: '',
            numero_identificacao: '',
            validade_identificacao: ''
        },
        observation: '',
        entity_type: ''
    },
    departs: [{
        area: '',
    }],
    addresses: [{
        village: '',
        city: '',
        type: [],
        region: '',
        country: '',
        apartado: '',
        localidade: '',
        contats: [],
        principal: '',
        observation: '',
        postal_code: '',
        street_name: '',
        address_detail: '',
    }],
    contacts: [{
        email: '',
        phone: '',
        principal: 'true',
        extensions: [],
        observation: '',
        mobile_phone: '',
        building_number: '',
        //departamentos: [],
        //codProjeto: [],
        //clientes: [],
        //person_responsables: [], 
        //colaborador:[],


    }],
    profile: { name: "Empresa" },
    notifications: []
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
